module.exports = __webpack_public_path__ + "static/1.0224464e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/msc/1.png
// module id = 886
// module chunks = 144974278801183 275805287939862